import { createSelector } from '@ngrx/store';
import { getMultipleOrderModalState } from '../reducers';

export const selectShippingConditionState = createSelector(
  getMultipleOrderModalState,
  state => state && state.shippingCondition,
);
export const selectShippingCondition = createSelector(selectShippingConditionState, (state) => state && state.payload);

export const selectActiveShippingConditionId = createSelector(
  selectShippingCondition,
  (state) => state && state.activeEntityId,
);

export const selectActiveShippingConditionEntity = createSelector(
  selectActiveShippingConditionId,
  selectShippingCondition,
  (shippingConditionId, state) => state && state.entities[shippingConditionId],
);

export const selectAllShippingConditionIds = createSelector(selectShippingCondition, (state) => state && state.ids);

export const selectAllShippingConditions = createSelector(
  selectAllShippingConditionIds,
  selectShippingCondition,

  (ids, state) => {
    // @TODO Its showing some kind of weird error, Im not able to to solve this right now
    const _ids: any[] = ids;
    const _entities: any = state.entities;
    return _ids.map(id => _entities[id]);
  },
);
